import { render, staticRenderFns } from "./newUploadFile.vue?vue&type=template&id=6d1e1558&scoped=true"
import script from "./newUploadFile.vue?vue&type=script&lang=js"
export * from "./newUploadFile.vue?vue&type=script&lang=js"
import style0 from "./newUploadFile.vue?vue&type=style&index=0&id=6d1e1558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e1558",
  null
  
)

export default component.exports